import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import { colors } from '../styles/colors'
import VoteIoClassic from '../svgr/VoteIoClassic'
import { useTonConnectModal } from '@tonconnect/ui-react'
import { DialogContainer } from './common.styles'

export const WalletConnectionRequiredDialog: FC<{
  className?: string
}> = ({ className }) => {
  const { open, state } = useTonConnectModal()

  if (state.status === 'opened') {
    return null
  }

  return (
    <DialogContainer className={className}>
      <IconContainer>
        <VoteIoClassic />
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            <FormattedMessage
              id="dialog.walletConnectionRequired.title"
              defaultMessage="Необходимо подключить кошелек"
            />
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography fontSize={14} fontWeight={400} color={colors.secondary}>
            <FormattedMessage
              id="dialog.walletConnectionRequired.description"
              defaultMessage="После подключения будут доступны все функции приложения"
            />
          </Typography>
        </DescriptionContainer>
      </ContentContainer>

      <ButtonContainer>
        <ConnectButton
          data-testid="wallet-connect-button"
          onClick={open}
          textColor={colors.white}
          textWeight={700}
        >
          <FormattedMessage
            id="dialog.walletConnectionRequired.connect"
            defaultMessage="Подключить"
          />
        </ConnectButton>
      </ButtonContainer>
    </DialogContainer>
  )
}

export const walletConnectionRequiredDialogPath =
  '/wallet-connection-required-dialog'

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 280px;
`

const ConnectButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
`
